// src/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBLYGLMNzibI4VO2lRKwrJc_Y3Ie-ec2sI",
  authDomain: "academiashapeemdialinkx.firebaseapp.com",
  projectId: "academiashapeemdialinkx",
  storageBucket: "academiashapeemdialinkx.firebasestorage.app",
  messagingSenderId: "86663664843",
  appId: "1:86663664843:web:4bf810f4bc6f358831774e",
  measurementId: "G-KVS0PV5X65"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
